export enum UserJobVacancyState {
  INVITED = "invited",
  SCHEDULED_INTERVIEW = "scheduled_interview",
  INTERVIEWED = "interviewed",
  ADDITIONAL_TEST = "additional_test",
  SELECTED = "selected",
  REJECTED = "rejected",
  INVITATION_ACCEPTED = "invitation_accepted",
  INVITATION_REJECTED = "invitation_rejected",
  HR_INTERVIEW = "hr_interview",
  USER_INTERVIEW = "user_interview",
  FAMILY_INTERVIEW = "family_interview",
  OFFERING = "offering",
  TECHNICAL_PRETEST = "technical_pretest",
  MEDICAL_CHECKUP = "medical_checkup",
  APPLIED = "applied",
  SHORTLISTED = "shortlisted",
  POOL = "pool",
  PROCESSED = "processed",
  PENDING = "pending",
  ASSESSMENT = "assessment",
  INTERVIEW = "interview",
  FILE_SELECTION = "file_selection",
  ARCHIVED = "archived",
  HIRED = "hired",
  GENERAL = "general",
  EXTERNAL_ASSESSMENT = "external_assessment",
}

export enum UserJobVacancyHistoryStatus {
  WAITING_FOR_REVIEW = "Waiting for review",
  WAITING_FOR_SUBMIT = "Waiting for submit",
  WAITING_FOR_RESULT = "Waiting for result",
  SCHEDULE_APPROVAL = "Schedule approval",
  IN_RESULT_REVIEW = "In result review",
  IN_PROFILE_REVIEW = "In profile review",
  REJECTED = "Rejected",
  PASSED = "Passed",
  HIRED = "Hired",
  COMPLETED = "Completed",
  LOCKED = "Locked",
}

export enum UserJobVacancyFormat {
  INVITE_FORMAT = "invite_format",
  LATEST_UPDATE_FORMAT = "latest_update_format",
  STUDY_CASE_FORMAT = "study_case_format",
}

export enum UserJobVacancySubmissionStatus {
  SUBMITTED_EARLY = "submitted_early",
  SUBMITTED_ON_TIME = "submitted_on_time",
  IN_PROGRESS = "in_progress",
  SUBMITTED_LATE = "submitted_late",
  OVERDUE = "overdue",
}

export type TUserJobVacancyState = `${UserJobVacancyState}`;
export type TUserJobVacancyHistoryStatus = `${UserJobVacancyHistoryStatus}`;
export type TUserJobVacancyFormat = `${UserJobVacancyFormat}`;
export type TUserJobVacancySubmissionStatus = `${UserJobVacancySubmissionStatus}`;

export const UserJobVacancySubmissionStatusCopy = {
  [UserJobVacancySubmissionStatus.SUBMITTED_EARLY]: "Submitted Early",
  [UserJobVacancySubmissionStatus.SUBMITTED_ON_TIME]: "Submitted On Time",
  [UserJobVacancySubmissionStatus.IN_PROGRESS]: "In Progress",
  [UserJobVacancySubmissionStatus.SUBMITTED_LATE]: "Submitted Late",
  [UserJobVacancySubmissionStatus.OVERDUE]: "Overdue",
};
